if (!customElements.get('product-bundle')) {
  customElements.define(
    'product-bundle',
    class ProductBundle extends HTMLElement {
      constructor() {
        super();

        this.radios = this.querySelectorAll('input[type="radio"]');
        this.itemsPanel = this.querySelector('.product-bundle__items');
        this.submitButton = this.querySelector('.product-bundle__submit');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorWrapper = this.querySelector('.product-bundle__error');
        this.errorText = this.querySelector('.product-bundle__error-text');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.decreaseButton = this.querySelector('[data-quantity-decrease]');
        this.increaseButton = this.querySelector('[data-quantity-increase]');
        this.singlePriceEl = this.querySelector('[data-single-price]');
        this.variantSelectA = this.querySelector('select[data-product="a"]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.radios.forEach((radio) => radio.addEventListener('change', this.updateMode.bind(this)));
        this.submitButton.addEventListener('click', this.onSubmit.bind(this));

        if (this.variantSelectA) {
          this.variantSelectA.addEventListener('change', this.updateSinglePrice.bind(this));
        }

        if (this.decreaseButton) this.decreaseButton.addEventListener('click', () => this.stepQuantity(-1));
        if (this.increaseButton) this.increaseButton.addEventListener('click', () => this.stepQuantity(1));
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', () => {
            const value = parseInt(this.quantityInput.value, 10);
            this.quantityInput.value = Number.isNaN(value) || value < 1 ? 1 : value;
          });
        }

        this.updateMode();
        this.initCountdown();
      }

      disconnectedCallback() {
        if (this.countdownInterval) clearInterval(this.countdownInterval);
      }

      getEndOfDay() {
        const d = new Date();
        d.setHours(23, 59, 59, 999);
        return d.getTime();
      }

      getEndOfWeek() {
        const d = new Date();
        const daysUntilSunday = (7 - d.getDay()) % 7;
        d.setDate(d.getDate() + daysUntilSunday);
        d.setHours(23, 59, 59, 999);
        return d.getTime();
      }

      getDurationEndTime(hours) {
        const storageKey = `product-bundle-countdown-${this.dataset.productId || ''}-${this.dataset.blockId || ''}`;
        let endTime = null;
        try {
          endTime = parseInt(sessionStorage.getItem(storageKey), 10);
        } catch (e) {
          endTime = null;
        }

        if (!endTime || Number.isNaN(endTime) || endTime <= Date.now()) {
          endTime = Date.now() + hours * 60 * 60 * 1000;
          try {
            sessionStorage.setItem(storageKey, String(endTime));
          } catch (e) {
            // sessionStorage unavailable; countdown just won't persist across reloads
          }
        }

        return endTime;
      }

      initCountdown() {
        const timerEl = this.querySelector('[data-countdown-timer]');
        const banner = this.querySelector('.product-bundle__countdown');
        if (!timerEl || !banner) return;

        const mode = this.dataset.countdownMode || 'duration';
        let endTime;

        if (mode === 'end_of_day') {
          endTime = this.getEndOfDay();
        } else if (mode === 'end_of_week') {
          endTime = this.getEndOfWeek();
        } else {
          const hours = parseFloat(this.dataset.countdownHours);
          if (!hours) return;
          endTime = this.getDurationEndTime(hours);
        }

        const pad = (n) => String(n).padStart(2, '0');

        const tick = () => {
          const remaining = endTime - Date.now();
          if (remaining <= 0) {
            banner.hidden = true;
            clearInterval(this.countdownInterval);
            return;
          }
          const totalSeconds = Math.floor(remaining / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const mins = Math.floor((totalSeconds % 3600) / 60);
          const secs = totalSeconds % 60;
          timerEl.textContent = `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
        };

        tick();
        this.countdownInterval = setInterval(tick, 1000);
      }

      updateSinglePrice() {
        if (!this.singlePriceEl || !this.variantSelectA) return;
        const selectedOption = this.variantSelectA.options[this.variantSelectA.selectedIndex];
        if (!selectedOption) return;

        const priceAmount = this.singlePriceEl.querySelector('[data-price-amount]');
        const compareAmount = this.singlePriceEl.querySelector('[data-compare-price-amount]');
        const newPrice = selectedOption.dataset.price;
        const newComparePrice = selectedOption.dataset.comparePrice;

        if (priceAmount && newPrice) priceAmount.textContent = newPrice;

        if (newComparePrice) {
          if (compareAmount) {
            compareAmount.textContent = newComparePrice;
          } else if (priceAmount) {
            const s = document.createElement('s');
            s.className = 'product-bundle__compare-price';
            s.setAttribute('data-compare-price-amount', '');
            s.textContent = newComparePrice;
            priceAmount.insertAdjacentElement('afterend', s);
          }
        } else if (compareAmount) {
          compareAmount.remove();
        }
      }

      stepQuantity(delta) {
        if (!this.quantityInput) return;
        const current = parseInt(this.quantityInput.value, 10) || 1;
        this.quantityInput.value = Math.max(1, current + delta);
      }

      get mode() {
        const checked = this.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : 'single';
      }

      updateMode() {
        if (this.itemsPanel) this.itemsPanel.hidden = this.mode !== 'bundle';
      }

      getVariantId(productKey) {
        if (this.mode === 'bundle' && this.itemsPanel) {
          const bundleScoped = this.itemsPanel.querySelector(`[data-product="${productKey}"]`);
          if (bundleScoped) return bundleScoped.value;
        }
        const select = this.querySelector(`select[data-product="${productKey}"]`);
        if (select) return select.value;
        const hiddenInput = this.querySelector(`input[data-product="${productKey}"]`);
        return hiddenInput ? hiddenInput.value : null;
      }

      showError(message) {
        if (!this.errorWrapper || !this.errorText) return;
        this.errorText.textContent = message || 'Something went wrong, please try again.';
        this.errorWrapper.hidden = false;
      }

      onSubmit(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const variantA = this.getVariantId('a');
        const isBundle = this.mode === 'bundle';
        const quantityA = isBundle ? 1 : parseInt((this.quantityInput && this.quantityInput.value) || 1, 10) || 1;
        const items = [{ id: variantA, quantity: quantityA }];
        if (isBundle) {
          const variantB = this.getVariantId('b');
          if (variantB) items.push({ id: variantB, quantity: 1 });
        }

        if (!variantA) {
          this.showError('Please select an option.');
          return;
        }

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');
        if (this.errorWrapper) this.errorWrapper.hidden = true;

        const body = { items };
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error('product-bundle: cart add returned an error response', response);
              let message = response.description || response.message;
              if (!message && response.errors) {
                message =
                  typeof response.errors === 'string' ? response.errors : JSON.stringify(response.errors);
              }
              this.showError(message);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-bundle',
                productVariantId: variantA,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!response.key && Array.isArray(response.items) && response.items.length) {
              response.key = response.items[0].key;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-bundle',
              cartData: response,
            });
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error('product-bundle: cart add request failed', e);
            this.showError();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }
    }
  );
}
